import { getSourceHelpContent, getSourceHelpDocsUrl } from "./SourceHelpRegistry";
import type {
  ConnectionHelpPanelProps,
  ConnectionHelpPanelViewModel,
} from "./ConnectionHelpPanel.ViewModel.types";

export const useConnectionHelpPanelViewModel = ({
  source,
}: Pick<ConnectionHelpPanelProps, "source">): ConnectionHelpPanelViewModel => {
  return {
    docsUrl: getSourceHelpDocsUrl(source.id),
    hasRegisteredContent: getSourceHelpContent(source.id) !== null,
  };
};
